import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchBlockOutDates(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('appointment/block-out-dates', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteBlockOutDate(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`appointment/block-out-dates/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
